export default __webpack_public_path__ + "static/media/construction.5b7bd4af.jpg";